import NotFound from './NotFound.vue';
import Login from './Login.vue';
import businesses from './businesses';
import sessions from './sessions';
import protocols from './protocols';

export default {
  NotFound,
  Login,
  businesses,
  sessions,
  protocols,
};
